import { render, staticRenderFns } from "./CodigoOrionAux.vue?vue&type=template&id=245ecefa"
import script from "./CodigoOrionAux.vue?vue&type=script&lang=js"
export * from "./CodigoOrionAux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports